import {apiV2} from "../../api/axiosConfig";
import {useQuery} from "react-query";
import {AutoCheckInConfig} from "./types";

async function fetchCheckInConfigurations(clientID: string | undefined) : Promise<AutoCheckInConfig[]> {
    if (!clientID) {
        return []
    }
    const { data } = await apiV2.get<AutoCheckInConfig[]>(`auto-check-in-config?clientID=${clientID}`)
    return data

}


export function useGetCheckInConfigurations( clientID: string | undefined ) {
    return useQuery<AutoCheckInConfig[]>({
        queryKey: ["autoCheckInConfigs", clientID],
        queryFn: () => fetchCheckInConfigurations(clientID),
        enabled: Boolean(clientID),
    });
}